module.exports = __webpack_public_path__ + "static/media/twitterX-circle-color.ba047a36.svg";